import React from 'react';

import classes from './SwymoHeader.module.scss';
import { SwymoLogo, SwymoLogoProps } from '../../SwymoLogo/SwymoLogo';
import { HeaderBar, HeaderBarProps } from '../HeaderBar/HeaderBar';

type SwymoHeaderProps = Omit<HeaderBarProps, 'children'> &
  Pick<SwymoLogoProps, 'variant'>;

/**
 * Transparent brand header for redesigned public pages.
 */
const SwymoHeader = ({ variant = 'white', ...props }: SwymoHeaderProps) => {
  return (
    <HeaderBar {...props}>
      <SwymoLogo variant={variant} className={classes.logo} />
    </HeaderBar>
  );
};

export { SwymoHeader };
